import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Badge } from "@/components/ui/badge";
import { PieChart } from "lucide-react";
import { INVENTORY } from "@/constants/testIds";

/** Margen por servicio = precio de venta - costo de insumos (según la receta configurada en Servicios). */
export default function MarginsTab({ margins, loading }) {
  if (loading) return <p className="text-center text-muted-foreground py-12">Cargando margenes...</p>;

  if (margins.length === 0) {
    return (
      <div className="bg-white border border-border rounded-xl p-12 text-center">
        <PieChart className="w-10 h-10 text-muted-foreground mx-auto mb-3" />
        <p className="text-muted-foreground">Todavía no hay servicios activos para calcular margen.</p>
      </div>
    );
  }

  return (
    <div className="space-y-4">
      <p className="text-sm text-muted-foreground">
        El costo de insumos se calcula según la "receta" configurada en cada servicio (editable desde Servicios).
        Los servicios sin receta muestran margen 100% (costo $0).
      </p>
      <div className="bg-white border border-border rounded-xl overflow-x-auto">
        <Table data-testid={INVENTORY.marginsTable}>
          <TableHeader>
            <TableRow>
              <TableHead>Servicio</TableHead>
              <TableHead>Precio</TableHead>
              <TableHead>Costo insumos</TableHead>
              <TableHead>Margen</TableHead>
              <TableHead>Margen %</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {margins.map((m) => (
              <TableRow key={m.service_id} data-testid={`${INVENTORY.marginRowPrefix}${m.service_id}`}>
                <TableCell className="font-medium text-foreground">{m.service_name}</TableCell>
                <TableCell>${m.price.toFixed(2)}</TableCell>
                <TableCell className="text-muted-foreground">${m.recipe_cost.toFixed(2)}</TableCell>
                <TableCell className="font-medium text-brand">${m.margin.toFixed(2)}</TableCell>
                <TableCell>
                  <Badge className={`border-none font-normal ${m.margin_pct >= 50 ? "bg-[#E3EDE1] text-[#5B7A54]" : "bg-[#F4E4D6] text-[#B5793A]"}`}>
                    {m.margin_pct}%
                  </Badge>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </div>
  );
}
